import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedNews() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 -mt-10 relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 no-underline"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`黑料不打烊 ${article.category} ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-white whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold font-heading text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(article.views / 10000).toFixed(1)}万
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}